import { createFeatureSelector } from "@ngrx/store";

import { DataTransactionsState } from "../models/shared/data-transactions-state";
import { StoreKeys } from "../store-keys";

export class DataTransactionsSelectors {
	static readonly dataTransactions = createFeatureSelector<DataTransactionsState>(
		StoreKeys.dataTransactionsStateKey
	);
}
